import { RuleDefinition } from 'controls/queryBuilder/ruleDefinition';
import { getOptionsLazy } from 'components/Select/utils/getOptionsLazy';
import { translator } from 'core/localization';

const i18n = translator({
	Columns: {},
	Path: {},
});

export type ApiRequestPayload = {
	[p: string]: unknown;
	filter: RuleDefinition;
	sort: { field: string; dir: 'asc' | 'desc' }[];
};

export enum GroupByMode {
	columns = 'columns',
	path = 'path',
}

export const getGroupByModeOptions = getOptionsLazy(() => {
	return [
		{
			label: i18n('Group by columns'),
			value: GroupByMode.columns,
		},
		{
			label: i18n('Group by path'),
			value: GroupByMode.path,
		},
	];
});
